import React from 'react';
import { FadeIn } from './ui';
import { IMAGES } from './constants';
const VISUALS = [{
  img: IMAGES.problem,
  alt: 'Persona desvelada a las 3am',
  caption: 'Cuando el mundo duerme y vos no podés.'
}, {
  img: IMAGES.alone,
  alt: 'Persona sola en medio de una multitud',
  caption: 'Rodeado de gente pero sintiéndote solo.'
}, {
  img: IMAGES.hero,
  alt: 'Teléfono iluminado en una habitación oscura',
  caption: 'A veces solo necesitás que alguien esté.'
}];
export function ProblemVisuals() {
  return <section className="w-full bg-[#213354] px-6 py-20 sm:py-28" data-id="element-91">
      <div className="mx-auto grid max-w-6xl gap-6 sm:grid-cols-3" data-id="element-92">
        {VISUALS.map((v, i) => <FadeIn key={i} delay={i * 0.12} data-id="element-93">
            <figure data-id="element-94">
              <div className="overflow-hidden rounded-2xl border border-[#8BA3C7]/20" data-id="element-95">
                <img src={v.img} alt={v.alt} className="aspect-square w-full object-cover" data-id="element-96" />
              </div>
              <figcaption className="mt-4 text-center text-white/80 italic" data-id="element-97">
                {v.caption}
              </figcaption>
            </figure>
          </FadeIn>)}
      </div>
    </section>;
}